import { ChangeEvent, FunctionComponent, useEffect, useState } from "react";

import { CircularProgress } from "@mui/material";

import { Link } from "react-router-dom";

import { InputField } from "@/components/InputField/InputField";
import { CustomColumnFrequency, CustomColumnTypes } from "@/enum/list.enum";
import { classNames } from "@/utils/classNames";

import { useUpdateColumnValueMutation } from "@/pages/Private/redux/profileTracker/profileTracker.api";

import { LinkedinIcon } from "@/components/LinkedinIcon/LinkedinIcon";

import { Tooltip } from "@/components/Tooltip/Tooltip";

import { ColumnConfig } from "../../../List/schema/columnConfig";
import { ColumnValue } from "../../../List/schema/columnValue";
import { TrackerOrganization } from "../../schema/trackerOrganizations";

export interface CustomDepartmentSizeColumnProps {
	showEdit?: { id: number; name: string };
	columnValue?: ColumnValue;
	columnConfig: ColumnConfig;
	row: TrackerOrganization;
	customColumnNumberValue?: number | null;
	setCustomColumnNumberValue: (value: number | null) => void;
	setShowEdit: (value: { id: number; name: string }) => void;
	type: CustomColumnTypes;
}

export const CustomDepartmentSizeColumn: FunctionComponent<CustomDepartmentSizeColumnProps> = ({
	showEdit,
	columnValue,
	columnConfig,
	row,
	customColumnNumberValue,
	setCustomColumnNumberValue,
	setShowEdit,
	type,
}) => {
	const [updatePerson, { isLoading }] = useUpdateColumnValueMutation();

	const [value, setValue] = useState<number | null>(null);

	useEffect(() => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const getValue = (cVal: any) => {
			try {
				return cVal?.answer !== undefined && cVal?.answer !== null
					? cVal?.answer?.toString()
					: cVal?.title || cVal?.commentary || cVal || "";
			} catch (e) {
				console.log(e);
			}
		};

		if (columnValue?.value) {
			setValue(getValue(columnValue.value));
		} else if (customColumnNumberValue) {
			setValue(customColumnNumberValue);
		}
	}, [columnValue, customColumnNumberValue]);

	if (isLoading) {
		return <CircularProgress />;
	}

	if (showEdit?.id === row.id && showEdit?.name === columnConfig.name) {
		return (
			<InputField
				autoFocus
				handleBlur={() => {
					setShowEdit({ id: 0, name: "" });
				}}
				handleChange={function (event: ChangeEvent<HTMLInputElement>): void {
					setValue(+event.target.value || null);
				}}
				name={columnConfig.name}
				type="number"
				value={value || ""}
				onKeyDown={(e) => {
					if (e.key === "Enter") {
						updatePerson({
							id: row.id,
							columnId: columnConfig.id,
							customColumnName: columnConfig.name,
							value: value || null,
							customColumnType: type,
							frequency: CustomColumnFrequency.ONCE,
						});
						setCustomColumnNumberValue(null);
						setShowEdit({ id: 0, name: "" });
					}
				}}
			/>
		);
	} else {
		return (
			<Tooltip
				content={
					row?.organization?.estimatedNumEmployees && value && value > 0
						? `${((value / row.organization.estimatedNumEmployees) * 100).toFixed(
								2
							)}% of all employees`
						: ""
				}
				disabled={!row?.organization?.estimatedNumEmployees || !!(value && value <= 0)}
			>
				<div className="flex flex-row items-center gap-2">
					<button
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							// setCustomColumnNumberValue(columnValue?.value ? (columnValue.value as number) : null);

							setShowEdit({ id: row.id, name: columnConfig.name });
						}}
					>
						{
							<div
								className={classNames(
									"h-[26px] min-w-[100px] cursor-pointer hover:bg-brand-light hover:opacity-[0.7] leading-tight hover:text-white rounded p-1",
									"text-right"
								)}
							>
								{value}
							</div>
						}
					</button>
					{value && value > 0 && (
						<Link
							target="_blank"
							to={`https://www.linkedin.com/search/results/people/?currentCompany=%5B%22${
								row?.organization?.companyLinkedinId
							}%22%5D&keywords=${(columnConfig.config as string[])
								.map((e) => `${e}`)

								.join(" OR ")}&titleFreeText=${(columnConfig.config as string[])
								.map((e) => `${e}`)
								.join(" OR ")}&origin=GLOBAL_SEARCH_HEADER&sid=XC.`}
							onClick={(e) => {
								e.stopPropagation();
							}}
						>
							<LinkedinIcon />
						</Link>
					)}
				</div>
			</Tooltip>
		);
	}
};
